export default __webpack_public_path__ + "static/media/bg-4.f6a8551b.png";